var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"folded"},[_c(_vm.foldedComponent,{tag:"component",attrs:{"item":_vm.foldedItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }